module.exports = __webpack_public_path__ + "media/video.673ae74f.mp4";